module.exports = __webpack_public_path__ + "banquet/components/AccountSettingsModal/images/large_close.59d6f509f1a81349bfd7cec561095679.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AccountSettingsModal/images/large_close.png
// module id = 1647
// module chunks = 1